import { Box } from "@mui/material";

export function Icon() {
  return (
    <Box
      component="img"
      sx={{
        height: 60,
        width: 60,
      }}
      alt="Beardiface Logo"
      src="/Beardiface-Logo.svg"
    />
  );
}
